// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    register: {
      root: `${ROOTS.AUTH}/register`,
      confirm: `${ROOTS.AUTH}/register/confirm`,
      account: `${ROOTS.AUTH}/register/account`,
      verify: `${ROOTS.AUTH}/register/account/verify`,
      organisation: `${ROOTS.AUTH}/register/organisation`,
      candidate: `${ROOTS.AUTH}/register/candidate`,
    },
    reset: `${ROOTS.AUTH}/password-reset`,
    accept_invite: `${ROOTS.AUTH}/accept-invite`,
    connection_request: `/connection-requests`,
  },
  // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}/activity`,
    account: {
      root: `${ROOTS.DASHBOARD}/account`,
      security: `${ROOTS.DASHBOARD}/account/security`,
      notifications: `${ROOTS.DASHBOARD}/account/notifications`,
      settings: `${ROOTS.DASHBOARD}/account/settings`,
    },
    profile: { root: `${ROOTS.DASHBOARD}/profile`, edit: `${ROOTS.DASHBOARD}/profile` },
    jobs: {
      root: `${ROOTS.DASHBOARD}/jobs`,
      create: `${ROOTS.DASHBOARD}/jobs/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/jobs/edit/${id}`,
    },
    connections: {
      root: `${ROOTS.DASHBOARD}/connections`,
      clients: `${ROOTS.DASHBOARD}/connections/clients`,
      recruiters: `${ROOTS.DASHBOARD}/connections/recruiters`,
    },
    admin: {
      organization: {
        root: `${ROOTS.DASHBOARD}/admin/organisation`,
        company_profile: `${ROOTS.DASHBOARD}/admin/organisation/company-profile`,
        users: `${ROOTS.DASHBOARD}/admin/organisation/users`,
        department: `${ROOTS.DASHBOARD}/admin/organisation/departments`,
        domains: `${ROOTS.DASHBOARD}/admin/organisation/domains`,
      },
      connection_management: {
        root: `${ROOTS.DASHBOARD}/admin/connections`,
      },
      billing: {
        root: `${ROOTS.DASHBOARD}/admin/billing`,
      },
      documents: {
        root: `${ROOTS.DASHBOARD}/admin/documents`,
      },
    },
    restricted: {
      organizations: {
        root: `${ROOTS.DASHBOARD}/restricted/organisations`,
      },
      accounts: { root: `${ROOTS.DASHBOARD}/restricted/accounts` },
    },
  },
  experience_verification: '/experience-verification',
};
